import { useState, useCallback } from 'react';

export const useGlobalLoader = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('Loading your application...');

  const showLoader = useCallback((loadingMessage?: string) => {
    if (loadingMessage) {
      setMessage(loadingMessage);
    }
    setIsLoading(true);
  }, []);

  const hideLoader = useCallback(() => {
    setIsLoading(false);
    setMessage('Loading your application...');
  }, []);

  const updateMessage = useCallback((newMessage: string) => {
    setMessage(newMessage);
  }, []);

  return {
    isLoading,
    message,
    showLoader,
    hideLoader,
    updateMessage
  };
};
